import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import Button from 'components/Button';
import EmptyView from 'components/EmptyView';

const NoFiles = ({ addNewFile }) => (
  <EmptyView>
    <i className="icon-no-projects" />
    <p>You have no files </p>
    <p>
      Please{' '}
      <Button isLink data-test="add-file" onClick={addNewFile}>
        add
      </Button>{' '}
      a new file
    </p>
  </EmptyView>
);

NoFiles.propTypes = {
  addNewFile: PropTypes.func,
};

NoFiles.defaultProps = {
  addNewFile: noop,
};

export default NoFiles;
